import BaseCadastro from "components/BaseCadastro";
import { useToastContext } from "components/alert/ToastContext";
import MarcaVeiculo from 'model/gestao/frotas/MarcaVeiculo';
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import MarcaVeiculoService from 'service/gestao/frotas/MarcaVeiculoService';
import "react-hook-form";
import {Controller, useForm} from "react-hook-form";
import { Label } from "components/input/Label";

const marcaVeiculoService = new MarcaVeiculoService();

export default function MarcaVeiculoCadastro() {

    const [queryParameters] = useSearchParams();

    const {control, clearErrors, setError, setFocus, register, formState: {errors}} = useForm();

    const [marcaVeiculo, setMarcaVeiculo] = useState<MarcaVeiculo>(new MarcaVeiculo());
    const [titulo, setTitulo] = useState<string>('Marca');
    
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();


    function validar() {

        if (!marcaVeiculo.nome) {
            setError("nome", {type: "manual", message: "Nome é Obrigatório"}, {shouldFocus: true})
            return false;
        }
        return true;
    }

    return (

        <BaseCadastro model={marcaVeiculo} service={marcaVeiculoService} setModel={(value: MarcaVeiculo) => setMarcaVeiculo(value)} getNewModel={() => new MarcaVeiculo()}
            novoCadastro validar={() => validar()} urlService="/marcaVeiculo" pathCadastro="/marcaVeiculo" tituloPagina={titulo}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}

            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText 
                        className={errors.nome ? "p-invalid" : ""}
                        required value={marcaVeiculo.nome} 
                        style={{ width: '30%' }} 
                        {...register("nome", {
                            onChange: (e) => {
                                setMarcaVeiculo({ ...marcaVeiculo, nome: e.target.value })
                                clearErrors("nome")
                            } 
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

        </BaseCadastro>
    )
}
